import React from "react";
import { Link } from "react-router-dom";
import "./StepBtn.scss";
import { Box, CircularProgress } from "@mui/material";

import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

export const StepBtn = ({ nextLink, prevLink, onSubmit, loading, backgroundColor }) => {
  // While a step is submitting, swallow further clicks so the user can't
  // double-submit or navigate away mid-request.
  const handleClick = (e) => {
    if (loading) {
      e.preventDefault();
      return;
    }
    onSubmit && onSubmit(e);
  };

  return (
    <Box className={`step-btn${loading ? " is-loading" : ""}`}>
      {prevLink && (
        <Link
          className="prev-btn"
          to={prevLink}
          onClick={(e) => loading && e.preventDefault()}
        >
          <ArrowRightAltIcon />
        </Link>
      )}
      <>
        <Link className="center-btn" to={nextLink} onClick={handleClick}>
          {loading ? (
            <CircularProgress size={24} thickness={5} sx={{ color: "#000" }} />
          ) : (
            <span>Next step</span>
          )}
        </Link>
        <Link className="next-btn" to={nextLink} onClick={handleClick}>
          <ArrowRightAltIcon />
        </Link>
      </>
    </Box>
  );
};
